const FOLLOWERS = "/api/followers";
const FOLLOWINGS = "/api/followings";

const exportedObject = {
  FOLLOWERS,
  FOLLOWINGS
};

export default exportedObject;
